import React from "react";

function SalonGridItems(props) {
  const { children } = props;

  return <>{children}</>;
}

export default SalonGridItems;
